export const sygnet = ['160 160', `
  <title>nmdc edge</title>
  <g>
  </g>
`]
